exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.main-block-options__btn[data-v-3d25fde5] .v-icon {\n    color: var(--grey-pipe);\n}\n.menu-btn.active[data-v-3d25fde5] .v-icon {\n    color: var(--aqua-active);\n}\n", ""]);

